/** Agent visual identities (frontend-only mapping for avatars & teasers). */

export const AGENT_VISUALS = {
  gaby: {
    color: "#3B82F6",
    bgSoft: "rgba(59,130,246,0.12)",
    avatar: "/agents/gaby-poster.png",
    coverage: "live",
    description:
      "Chef d'orchestre de la suite. Il synthétise la santé de ton entreprise et te dispatche vers le bon spécialiste. Sa force : la vue d'ensemble.",
    skills: ["Orchestration", "Snapshot business", "Dispatch intelligent", "Priorisation"],
    examples: [
      "Donne-moi l'état général de la boîte ce matin",
      "Où en sommes-nous sur nos 10 places pilotes ?",
      "Quel agent doit gérer un impayé ?",
    ],
  },
  commerce: {
    color: "#D4A017",
    bgSoft: "rgba(212,160,23,0.12)",
    avatar: "/agents/commerce-poster.png",
    coverage: "live",
    description:
      "Directeur commercial multi-apps. Il pilote les abonnements, licences, essais, factures et paiements de TOUTES tes applications SaaS (CHANTIX, HYGIX...). Vue transversale sans jamais mélanger les données clients.",
    skills: ["Abonnements", "Licences & essais", "MRR & CA par app", "Relances", "Stripe & renouvellements"],
    examples: [
      "Combien HYGIX a rapporté ce mois-ci ?",
      "Quelle app est la plus rentable ?",
      "Quels abonnements arrivent à échéance cette semaine ?",
    ],
  },
  chanti: {
    color: "#F59E0B",
    bgSoft: "rgba(245,158,11,0.12)",
    avatar: "/agents/thierry-poster.png",
    coverage: "live",
    description:
      "Product Manager IA. Il transforme le feedback utilisateurs en roadmap actionnable. Il priorise, chiffre l'impact, écrit les specs.",
    skills: ["Analyse feedback", "Roadmap produit", "Priorisation impact/effort", "Specs techniques"],
    examples: [
      "Analyse les feedbacks CHANTIX et sors les 3 priorités",
      "Quels bugs bloquants remontent nos users ?",
      "Rédige la spec de la feature 'export PDF chantier'",
    ],
  },
  casper: {
    color: "#EF4444",
    bgSoft: "rgba(239,68,68,0.12)",
    avatar: "/agents/casper-poster.png",
    coverage: "advisory",
    description:
      "Legal & Compliance IA. RGPD, CGU/CGV SaaS, facturation électronique 2026, contrats, propriété intellectuelle. L'expert que tu appelles avant de signer.",
    skills: ["RGPD & DPA", "CGU/CGV SaaS", "e-invoicing 2026", "Contrats & PI"],
    examples: [
      "Rédige mes CGV SaaS pour CHANTIX",
      "Politique de confidentialité conforme RGPD 2026",
      "Modèle de contrat prestataire freelance",
    ],
  },
  clara: {
    color: "#EC4899",
    bgSoft: "rgba(236,72,153,0.12)",
    avatar: "/agents/clara-poster.png",
    coverage: "hybrid",
    description:
      "Marketing & Growth IA. Contenu, prospection, séquences d'onboarding, relances impayés. La voix de GABRYX sur tous les canaux.",
    skills: ["Contenu & posts", "Prospection", "Emails d'onboarding", "Relances clients"],
    examples: [
      "Post LinkedIn pour attirer les 9 prochains pilotes",
      "Séquence onboarding J0/J3/J7/J30 pour un nouveau signup",
      "Relance amiable pour un impayé J+7",
    ],
  },
  fisco: {
    color: "#10B981",
    bgSoft: "rgba(16,185,129,0.12)",
    avatar: "/agents/ulrich-poster.png",
    coverage: "live",
    description:
      "Facturation & Finance IA. Émission factures, suivi MRR/ARR, encaissements, dunning automatique, TVA & seuils micro-entreprise.",
    skills: ["Factures conformes", "MRR & ARR", "Dunning", "TVA & seuils micro"],
    examples: [
      "Émets la facture d'août pour Thierry Rivière (29 €)",
      "Quel est mon MRR ce mois ?",
      "Quels abonnés sont en retard de paiement ?",
    ],
  },
  rhea: {
    color: "#8B5CF6",
    bgSoft: "rgba(139,92,246,0.12)",
    avatar: "/agents/rhea-poster.png",
    coverage: "live",
    description:
      "Relation abonnés & pilotes IA. Elle veille sur l'expérience de tes users : onboarding, activation, détection de churn, réactivation.",
    skills: ["Onboarding", "Activation", "Détection churn", "Réactivation"],
    examples: [
      "Qui n'a pas été actif depuis 14 jours ?",
      "Message de bienvenue pour un nouveau pilote CHANTIX",
      "Détecte les 3 users les plus à risque de partir",
    ],
  },
  opera: {
    color: "#06B6D4",
    bgSoft: "rgba(6,182,212,0.12)",
    avatar: "/agents/opera-poster.png",
    coverage: "live",
    description:
      "Ops & Support IA. Il triage les tickets, coordonne les incidents, écrit les playbooks internes, veille sur les SLA de réponse.",
    skills: ["Tickets support", "Incidents", "Playbooks", "SLA & KPIs ops"],
    examples: [
      "Priorise ma pile de tickets support",
      "Playbook 'panne CHANTIX en pleine production'",
      "Rédige un template de réponse premier ticket",
    ],
  },
  visio: {
    color: "#F97316",
    bgSoft: "rgba(249,115,22,0.12)",
    avatar: "/agents/visio-poster.png",
    coverage: "live",
    description:
      "Business Analytics IA. Elle transforme les données CHANTIX + GABRYX en dashboards, KPIs, alertes. Les chiffres parlent — elle les fait parler.",
    skills: ["KPIs business", "MRR & conversion", "Détection d'anomalies", "Reporting hebdo"],
    examples: [
      "Snapshot exécutif de la semaine",
      "Quel est mon taux de conversion visiteur → pilote ?",
      "Détecte les anomalies dans mes signups récents",
    ],
  },
  voxy: {
    color: "#A855F7",
    bgSoft: "rgba(168,85,247,0.12)",
    avatar: "/agents/voxy-poster.png",
    coverage: "advisory",
    description:
      "Communication vocale IA. Il appelle les nouveaux signups dans les 5 min pour qualifier, ou tes prospects tièdes pour les réactiver. Bientôt branché Twilio.",
    skills: ["Appels sortants", "Qualification vocale", "Relances téléphoniques", "Scripts"],
    examples: [
      "Script d'appel pour un nouveau pilote CHANTIX",
      "Trame de qualification pour un prospect tiède",
      "Message vocal de bienvenue quand quelqu'un s'inscrit",
    ],
  },
};

export const COMING_SOON_VISUALS = {};
